import Banner from "./banner";
import LearnMore from "./LearnMore";
import "./BuildExperience.css";


const BuildExperience = (props) => {
  return (
    <>
      {props.SectionsImg.section1 && (<>  <section style={styles.container} className="bx-container">
        <div style={styles.imageSection} className="bx-image-section">
          <img
            src={props.SectionsImg.imagesec1}
            alt="Construction site"
            style={styles.mainImage}
            className="bx-main-image"
          />
          <div style={styles.smallImagesWrapper} className="bx-small-images-wrapper">
            <img
              src={props.SectionsImg.imagesec11}
              alt="Workers 1"
              style={styles.smallImage}
              className="bx-small-image"
            />
            <img
              src={props.SectionsImg.imagesec12}
              alt="Workers 2"
              style={styles.smallImage}
              className="bx-small-image"
            />
          </div>
        </div>

        <div style={styles.textSection} className="bx-text-section">
          <p style={styles.preTitle} className="bx-pre-title">{props.SectionsImg.Highlight1 ? props.SectionsImg.Highlight1 : props.SectionsImg.Highlight} - {props.SectionsImg.heading1}</p>
          <h2 style={styles.title} className="bx-title">{props.SectionsImg.heading1}</h2>
          <p style={styles.description} className="bx-description">{props.SectionsImg.paragraph1} </p>
          <LearnMore SectionsImg={props.SectionsImg.link1} />
        </div>

      </section>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br /></>)}

      {props.SectionsImg.section2 && (<>

        <section style={styles.container} className="bx-container">


          <div style={styles.textSection} className="bx-text-section">
            <p style={styles.preTitle} className="bx-pre-title">{props.SectionsImg.Highlight2 ? props.SectionsImg.Highlight2 : props.SectionsImg.Highlight} - {props.SectionsImg.heading2}</p>
            <h2 style={styles.title} className="bx-title">{props.SectionsImg.heading2}</h2>
            <p style={styles.description} className="bx-description">{props.SectionsImg.paragraph2} </p>
            <LearnMore SectionsImg={props.SectionsImg.link2} />
          </div>

          <div style={styles.imageSection} className="bx-image-section">
            <img
              src={props.SectionsImg.imagesec2}
              alt="Construction site"
              style={styles.mainImage}
              className="bx-main-image"
            />
            <div style={styles.smallImagesWrapper} className="bx-small-images-wrapper">
              <img
                src={props.SectionsImg.imagesec21}
                alt="Workers 1"
                style={styles.smallImage}
                className="bx-small-image"
              />
              <img
                src={props.SectionsImg.imagesec22}
                alt="Workers 2"
                style={styles.smallImage}
                className="bx-small-image"
              />
            </div>
          </div>
        </section>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </>)}

      {props.SectionsImg.section3 && (<>

        <section style={styles.container} className="bx-container">
          <div style={styles.imageSection} className="bx-image-section">
            <img
              src={props.SectionsImg.imagesec3}
              alt="Construction site"
              style={styles.mainImage}
              className="bx-main-image"
            />
            <div style={styles.smallImagesWrapper} className="bx-small-images-wrapper">
              <img
                src={props.SectionsImg.imagesec31}
                alt="Workers 1"
                style={styles.smallImage}
                className="bx-small-image"
              />
              <img
                src={props.SectionsImg.imagesec32}
                alt="Workers 2"
                style={styles.smallImage}
                className="bx-small-image"
              />
            </div>
          </div>

          <div style={styles.textSection} className="bx-text-section">
            <p style={styles.preTitle} className="bx-pre-title">{props.SectionsImg.Highlight} - {props.SectionsImg.heading3}</p>
            <h2 style={styles.title} className="bx-title">{props.SectionsImg.heading3}</h2>
            <p style={styles.description} className="bx-description">{props.SectionsImg.paragraph3} </p>
            <LearnMore SectionsImg={props.SectionsImg.link3} />
          </div>
        </section>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </>)}


      {props.SectionsImg.section4 && (<>
        <section style={styles.container} className="bx-container">


          <div style={styles.textSection} className="bx-text-section">
            <p style={styles.preTitle} className="bx-pre-title">{props.SectionsImg.Highlight} - {props.SectionsImg.heading4}</p>
            <h2 style={styles.title} className="bx-title">{props.SectionsImg.heading4}</h2>
            <p style={styles.description} className="bx-description">{props.SectionsImg.paragraph4} </p>
            <LearnMore SectionsImg={props.SectionsImg.link4} />
          </div>

          <div style={styles.imageSection} className="bx-image-section">
            <img
              src={props.SectionsImg.imagesec4}
              alt="Construction site"
              style={styles.mainImage}
              className="bx-main-image"
            />
            <div style={styles.smallImagesWrapper} className="bx-small-images-wrapper">
              <img
                src={props.SectionsImg.imagesec41}
                alt="Workers 1"
                style={styles.smallImage}
                className="bx-small-image"
              />
              <img
                src={props.SectionsImg.imagesec42}
                alt="Workers 2"
                style={styles.smallImage}
                className="bx-small-image"
              />
            </div>
          </div>
        </section>
        <br />
        <br />
        <br />
        <br />
        <br />
      </>)}

      {props.SectionsImg.section5 && (<>

        <section style={styles.container} className="bx-container">
          <div style={styles.imageSection} className="bx-image-section">
            <img
              src={props.SectionsImg.imagesec5}
              alt="Construction site"
              style={styles.mainImage}
              className="bx-main-image"
            />
            <div style={styles.smallImagesWrapper} className="bx-small-images-wrapper">
              <img
                src={props.SectionsImg.imagesec51}
                alt="Workers 1"
                style={styles.smallImage}
                className="bx-small-image"
              />
              <img
                src={props.SectionsImg.imagesec52}
                alt="Workers 2"
                style={styles.smallImage}
                className="bx-small-image"
              />
            </div>
          </div>

          <div style={styles.textSection} className="bx-text-section">
            <p style={styles.preTitle} className="bx-pre-title">{props.SectionsImg.Highlight} - {props.SectionsImg.heading5}</p>
            <h2 style={styles.title} className="bx-title">{props.SectionsImg.heading5}</h2>
            <p style={styles.description} className="bx-description">{props.SectionsImg.paragraph5} </p>
            <LearnMore SectionsImg={props.SectionsImg.link5} />
          </div>
        </section>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </>)}



      <Banner imageUrl={props.Images} />
    </>
  );
};


const styles = {
  container: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    gap: "48px",
    padding: "40px 20px",
    boxSizing: "border-box",
    fontFamily: "'Georgia', serif",
    alignItems: "center",
  },
  imageSection: {
    flex: "1 1 0",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },
  mainImage: {
    width: "100%",
    height: "320px",
    objectFit: "cover",
    borderRadius: "6px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
    marginBottom: "20px",

    WebkitMaskImage: `
    linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 25%, rgba(0,0,0,1) 100%),
    linear-gradient(to right, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%),
    radial-gradient(ellipse closest-corner, rgba(0,0,0,2) 80%, rgba(0,0,0,0) 100%)
  `,
    maskImage: `
    linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 25%, rgba(0,0,0,1) 100%),
    linear-gradient(to right, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%),
    radial-gradient(ellipse closest-corner, rgba(0,0,0,2) 80%, rgba(0,0,0,0) 100%)
  `,

    WebkitMaskComposite: "destination-in",
    maskComposite: "intersect",
  },


  smallImagesWrapper: {
    display: "flex",
    gap: "20px",
    minWidth: 0,
  },
  smallImage: {
    width: "50%",
    height: "160px",
    objectFit: "cover",
    borderRadius: "3px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",

  },
  textSection: {
    flex: "1 1 0",
    minWidth: 0,
    maxWidth: "560px",
  },
  preTitle: {
    fontSize: "14px",
    fontWeight: "300",
    color: "#2e7d32",
    letterSpacing: "0.10em",
    textTransform: "uppercase",
    marginBottom: "8px",
    fontFamily: "'Inter', sans-serif",
    minWidth: 0,
    margin: "0 0 8px 0",
  },
  title: {
    fontSize: "clamp(30px, 4vw, 52px)",
    margin: "0 0 18px 0",
    fontWeight: "400",
    fontFamily: "'adobe-garamond-pro', serif",
    lineHeight: 1.1,
    overflowWrap: "anywhere",
  },
  description: {
    fontSize: "19px",
    lineHeight: "35px",
    marginBottom: "10px",
    color: "#222",
    fontFamily: "'Inter', sans-serif",
    texttransform: 'capitalize'


  },
  button: {
    backgroundColor: "rgb(0, 0, 0)",
    color: "white",
    border: "none",
    padding: "10px 32px",
    cursor: "pointer",
    borderRadius: "3px",
    letterSpacing: "0.05em",
    transition: "background-color 0.3s ease",
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    lineHeight: "26px",
    width: '50%'
  },

};

export default BuildExperience;
